import React from 'react'

class CheckBox extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}
    this.handleChange = this.handleChange.bind(this)
  }

  componentWillMount() {
    this.selectedCheckboxes = new Set();
  }

  handleChange(event) {
    const target = event.target
    const name = target.name
    let value = target.checked
    let finalValue = value

    if (this.props.multi === true) {
      value = target.value

      if (this.selectedCheckboxes.has(value)) {
        this.selectedCheckboxes.delete(value)
      } else {
        this.selectedCheckboxes.add(value)
      }

      let items = []

      this.selectedCheckboxes.forEach(function(value) {
        items.push(value)
      })

      finalValue = items
    }

    this.props.getInputValue(name, finalValue)
  }

  display() {
    if (this.props.multi === true) {
      return (
        <div className="form-checkboxes">
        {this.props.values.map((val, index) => {
          return (
            <div key={index} className="form-item form-type-checkbox">
              <input name={this.props.name} onChange={this.handleChange} type="checkbox" id={val+index} value={val} className="form-checkbox"/>  <label className="option vertical-top" htmlFor={val+index}>{val} </label>
            </div>
          )
        })}
        </div>
      )
    } else {
      return (
        <div className="form-checkboxes">
          <input name={this.props.name} onChange={this.handleChange} type="checkbox" id={this.props.name} value={this.props.values} className="form-checkbox"/>  <label className="option vertical-top" htmlFor={this.props.name}>{this.props.values} </label>
        </div>
      )
    }
  }

  render() {
    return this.display()
  }
}

export default CheckBox
